import { render, staticRenderFns } from "./AzureRostros.vue?vue&type=template&id=2687f914&scoped=true"
import script from "./AzureRostros.vue?vue&type=script&lang=js"
export * from "./AzureRostros.vue?vue&type=script&lang=js"
import style0 from "./AzureRostros.vue?vue&type=style&index=0&id=2687f914&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2687f914",
  null
  
)

export default component.exports